import { IConfigurations } from '@epicuro-next/platform/configuration';

export const FEATURE_NAME = 'config-strip-state';

/**
 * configuration keys for this module
 */
export enum ConfigStripStateConfigurationKeys {
  ValidatorFunctions = 'validator-functions',
  ShowNextButton = 'show-pBasket-next',
  CategoryField = 'product-category-field',
  BackOrderEnabled = 'back-order-enabled',
  ActiveVariantDateRangeEnabled = 'active-variant-date-range-enabled',
  SizeRunsEnabled = 'size-runs-enabled',
  SalesUnit = 'sales-unit',
  SkipInventoryCheck = 'skip-inventory-check',
  InStoreDateEnabled = 'in-store-date-enabled',
  BulkDeliveryPeriods = 'bulk-delivery-periods',
  CheckInventoryForBackOrder = 'check-inventory-for-back-order',
  LockSizeRunSelector = 'lock-size-run-selector',
  TrueDemandEnabled = 'true-demand-enabled',
}

/**
 * Configuration return types and default values for this module
 */
export interface ConfigStripStateConfigurations
  extends IConfigurations<ConfigStripStateConfigurationKeys> {
  /** JSON by default */
  [ConfigStripStateConfigurationKeys.ValidatorFunctions]: string;
  [ConfigStripStateConfigurationKeys.CategoryField]: string;
  [ConfigStripStateConfigurationKeys.BackOrderEnabled]: boolean;
  [ConfigStripStateConfigurationKeys.ActiveVariantDateRangeEnabled]: boolean;
  [ConfigStripStateConfigurationKeys.SalesUnit]: string;
  [ConfigStripStateConfigurationKeys.SizeRunsEnabled]: boolean;
  [ConfigStripStateConfigurationKeys.SkipInventoryCheck]: boolean;
  [ConfigStripStateConfigurationKeys.InStoreDateEnabled]: boolean;
  [ConfigStripStateConfigurationKeys.BulkDeliveryPeriods]: string;
  [ConfigStripStateConfigurationKeys.CheckInventoryForBackOrder]: boolean;
  [ConfigStripStateConfigurationKeys.LockSizeRunSelector]: string;
  [ConfigStripStateConfigurationKeys.TrueDemandEnabled]: boolean;
}
